import React from 'react';
// Components
import GeneralMainSection from '../general/GeneralMainSection';
import GeneralFooter from '../general/GeneralFooter';
// Images
import BathroomsImage2 from '../../assets/images/main/ascari-building-contractors-bathroom-hero.avif';
import BathroomsImage from '../../assets/images/main/ascari-building-contractors-landscaping-and-floor-bathrrom.webp';
import BathroomsImage3 from '../../assets/images/main/ascari-building-contractors-landscaping-and-floor-bathrrom-image.jpg';

function BathroomsPageMainContainer() {
  const bathroomsPageData = {
    headerSentence: 'Premium Bathroom Renovations & Installations',
    description:
      "Ascari Building Contractors specializes in transforming bathrooms into stunning, functional spaces. Whether you're looking for a sleek modern design, a classic luxury feel, or a complete refurbishment, we bring your vision to life with expert craftsmanship and attention to detail.",
    services: [
      {
        title: 'Full Bathroom Renovations',
        description:
          'Complete redesigns, from demolition to final fittings, creating modern and stylish spaces.',
      },
      {
        title: 'Custom Tiling & Flooring',
        description:
          'Expert installation of ceramic, porcelain, marble, and waterproof flooring solutions.',
      },
      {
        title: 'Shower & Bath Installations',
        description:
          'Installation of walk-in showers, freestanding baths, and wet rooms tailored to your space.',
      },
      {
        title: 'Plumbing & Heating',
        description:
          'Professional plumbing, underfloor heating, and radiator installations for efficiency and comfort.',
      },
      {
        title: 'Bespoke Vanity & Storage',
        description:
          'Custom-built vanity units, storage solutions, and mirror installations for a clutter-free space.',
      },
      {
        title: 'Waterproofing & Ventilation',
        description:
          'High-quality waterproofing and ventilation solutions to prevent mold and moisture issues.',
      },
    ],
    commitment:
      'We handle every aspect of your bathroom renovation, from plumbing to finishing touches, ensuring a stress-free experience with a high-quality result that stands the test of time.',
    mainImage: BathroomsImage,
    secondImage: BathroomsImage,
    mainImageAlt: 'Modern renovated bathroom with a walk-in shower',
    imageTwo: BathroomsImage2,
    imageThree: BathroomsImage3,
  };

  return (
    <main
      role='main'
      className='grid pt-8 sm:pt-10 md:pt-12 gap-12 lg:gap-24 w-full h-full'
    >
      <GeneralMainSection {...bathroomsPageData} />

      <GeneralFooter title={`Bathrooms`} />
    </main>
  );
}

export default BathroomsPageMainContainer;
